import {loadBlockLazyImages} from "../helpers/lazy-load";
import {smoothScrollCreate, smoothScrollKill} from "../scroll-smoother";


$('.js-open-popup-where-buy').click(function(){
  let popup_name = $(this).data('popup')
  let popup = $('.js-popup-where-buy')

  if (popup.length){
    popup.fadeIn()
    $('html').addClass('modal-open')

    smoothScrollKill()
    loadBlockLazyImages(popup)
  }
})


$(document).on('click', '.js-close-popup', function(){
  closePopup($(this))
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closePopup($('.js-popup-where-buy'))
  }
});


function closePopup(el){
  let popup = el.closest('.js-popup-where-buy')

  popup.fadeOut()
  $('html').removeClass('modal-open')
  smoothScrollCreate()
}
